<div>
    <div class="text-center text-2xl mb-8">
        {{ "section.notification-wizard.summary" | translate }}
    </div>

    <div class="w-full h-full border-slate-200 text-lg">
        <div class="flex flex-col flex-auto">

            <!-- Selected Users -->
            <div class="mx-1 md:mx-6 self-center w-full border rounded-md my-4 py-4 flex flex-col items-center bg-slate-50" *ngIf="notificationWizard.userIds && notificationWizard.userIds.length > 0">
                <span>{{ "section.notification-wizard.users" | translate }} ({{ notificationWizard.userCount || notificationWizard.userIds.length }})</span>
                <br />
                <div class="max-h-72 overflow-y-auto mt-2 w-fit">
                    <table class="w-full bg-white">
                        <tbody>
                            <tr *ngFor="let user of notificationWizard.userList" class="border rounded-sm">
                                <td class="text-left px-4 py-2" *ngIf="user.checked">
                                    <a class="text-primary cursor-pointer mr-1" target="_blank" [routerLink]="['/users/', user.id]">
                                        <i class="far fa-link"></i>
                                    </a>
                                    {{ user.id }}
                                </td>
                                <td class="text-left px-4 py-2" *ngIf="user.checked">{{ user.firstname }} {{ user.lastname }}</td>
                                <td class="text-left px-4 py-2" *ngIf="user.checked">{{ user.email }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Selected Groups -->
            <div class="mx-1 md:mx-6 self-center w-full border rounded-md my-4 py-4 flex flex-col items-center bg-slate-50" *ngIf="notificationWizard.groupIds && notificationWizard.groupIds.length > 0">
                <span>{{ "section.notification-wizard.groups" | translate }} ({{ notificationWizard.groupIds.length }})</span>
                <br />
                <div class="max-h-72 overflow-y-auto mt-2 w-fit">
                    <table class="w-full bg-white">
                        <tbody>
                            <tr *ngFor="let group of notificationWizard.groupList" class="border rounded-sm">
                                <td class="text-left px-4 py-2" *ngIf="group.checked">
                                    {{ group.name }}
                                </td>
                                <td class="text-left px-4 py-2" *ngIf="group.checked">
                                    {{ "section.notification-wizard.totalUsers" | translate }}: {{ group.usersCount || 0 }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Selected Company -->
            <div class="mx-1 md:mx-6 self-center w-full border rounded-md my-4 py-4 flex flex-col items-center bg-slate-50" *ngIf="notificationWizard.companyId">
                <span>{{ "section.notification-wizard.selectedCompany" | translate }}</span>
                <br />
                <div class="mt-2 w-fit">
                    <div class="bg-white px-4 py-2 border rounded-sm">
                        <span class="font-semibold">
                            {{ getSelectedCompanyName() }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="border rounded-md my-4 py-4 bg-slate-50" *ngIf="notificationWizard.attachmentType !== undefined">
                <span>{{ "section.notification-wizard.attachmentType" | translate }}</span>
                <br />
                <span class="font-semibold text-lg max-w-1/2">{{ notificationWizard.attachmentType?.name }}</span>
            </div>

            <div class="border rounded-md my-4 py-4 bg-slate-50">
                <span>{{ "section.notification-wizard.text-header" | translate }}</span>
                <br />
                <span class="font-semibold text-lg max-w-1/2">{{ notificationWizard.subject }}</span>
            </div>

            <div class="flex flex-col justify-center border rounded-md my-4 py-4 bg-slate-50">
                <span>{{ "section.notification-wizard.android_message" | translate }}</span>
                <br />
                <span class="font-semibold text-md max-w-1/2 self-center text-left">{{ notificationWizard.androidMessage }}</span>
            </div>

            <div class="flex flex-col justify-center border rounded-md my-4 py-4 bg-slate-50">
                <span>{{ "section.notification-wizard.iphone_message" | translate }}</span>
                <br />
                <span class="font-semibold text-md max-w-1/2 self-center text-left">{{ notificationWizard.iosMessage }}</span>
            </div>


            <div class="mx-1 md:mx-6 self-center w-full border rounded-md my-4 py-4 flex flex-col items-center bg-slate-50">
                <div class="flex flex-col md:flex-row md:max-w-1/2 self-center">
                    <div class="mt-2">
                        <mat-form-field class="fuse-mat-no-subscript w-full min-w-[200px] md:min-w-[250px]">
                            <mat-label>{{ "section.notification-wizard.time" | translate }}</mat-label>
                            <input matInput
                                   [(ngModel)]="notificationWizard.sendTime"
                                   [owlDateTime]="dt1"
                                   [owlDateTimeTrigger]="dt1"
                                   [min]="moment()"
                                   [disabled]="notificationWizard.sendNow"
                                   placeholder="Vyberte datum a čas" />
                            <i class="fal fa-times icon-size-6 clear-icon" (click)="clearDate($event)"></i>
                            <owl-date-time #dt1></owl-date-time>
                        </mat-form-field>
                    </div>
                    <div class="fuse-mat-no-subscript w-full self-center mt-3">
                        <mat-checkbox class="" name="sendNow" (ngModelChange)="sendNowChanged($event)" [(ngModel)]="notificationWizard.sendNow">
                            <mat-label class="fuse-mat-no-subscript">{{ "section.notification-wizard.now" | translate }}</mat-label>
                        </mat-checkbox>
                    </div>
                </div>
            </div>
        </div>

        <button mat-button class="text-lg w-80" (click)="save()" type="button">
            <i class="fa fas fa-check"></i>
            {{ "section.notification-wizard.save_n_send" | translate }}
        </button>
    </div>
</div>
